interface Amount {
    text: string
    value: number
}

export const MINIMUM_AMOUNT_OPTIONS: Amount[] = [
    {
        text: '$10',
        value: 10
    },
    {
        text: '$20 or less',
        value: 20
    },
    {
        text: '$30 or less',
        value: 30
    },
    {
        text: '$40 or less',
        value: 40
    },
    {
        text: '$50 or less',
        value: 50
    },
    {
        text: '$80 or less',
        value: 80
    },
    {
        text: '$100 or less',
        value: 100
    },
    {
        text: '$150 or less',
        value: 150
    }
]

export const RECHARGE_AMOUNT_OPTIONS: Amount[] = [
    {
        text: '$10',
        value: 10
    },
    {
        text: '$20',
        value: 20
    },
    {
        text: '$30',
        value: 30
    },
    {
        text: '$40',
        value: 40
    },
    {
        text: '$50',
        value: 50
    },
    {
        text: '$80',
        value: 80
    },
    {
        text: '$100',
        value: 100
    },
    {
        text: '$150',
        value: 150
    }
]
